import axios from "axios";
import authChoice from "../../auth";
import environment from "../../env";
import { apiWrapperGenerator } from "./lib";

function getBaseUrl() {
  return environment.backendType === "firebase"
    ? environment.service[environment.env].deephowApiServer
    : environment.service[environment.env]["china"].deephowApiServer;
}

const workspaceGroupServer = axios.create({
  baseURL: getBaseUrl(),
});

workspaceGroupServer.interceptors.request.use(
  async (config) => {
    config.headers["x-user-token"] = await authChoice().currentUser.getIdToken();
    return config;
  },
  (error) => Promise.resolve(error)
);

const apiWrapper = apiWrapperGenerator(workspaceGroupServer);

export const getWorkspaceGroups = (params = { needWorkspaces: true }) =>
  apiWrapper("get", `/v1/workspaces-groups/`, { params });

export const createWorkspaceGroup = (payload) => apiWrapper("post", `/v1/workspaces-groups/`, payload);

export const patchWorkspaceGroup = ({ id, name, locale }) =>
  apiWrapper("patch", `/v1/workspaces-groups/${id}`, { name, locale });

export const deleteWorkspaceGroup = (id) => apiWrapper("delete", `/v1/workspaces-groups/${id}`);

export default workspaceGroupServer;
